module.exports = "https://cdn01.riselinkedu.com/assets/images/student_default_avatar.f8ef158.png";